// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__AvYyy","content":"style_content__8gunN"};